import { Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const GROUP_COUNT = 6

const useStyles = makeStyles()((theme) => ({
    group: {
        padding: "1rem",
        borderTop: `1px solid ${theme.palette.tailwind.slate[100]}`,
        "&:first-of-type": {
            borderTop: "none",
        },
    },
    header: {
        width: "12rem",
        flexShrink: 0,
    },
    row: {
        flex: 1,
        borderRadius: ".75rem",
    },
}))

export function MeetingRoomsGroupsSkeleton() {
    const { classes } = useStyles()

    return (
        <>
            {Array.from({ length: GROUP_COUNT }, (_, index) => (
                <Stack key={index} direction="row" spacing="1.5rem" className={classes.group}>
                    <Stack spacing=".25rem" className={classes.header}>
                        <Skeleton width="6rem" />
                        <Skeleton width="9rem" />
                    </Stack>
                    <Skeleton variant="rectangular" height="4rem" className={classes.row} />
                </Stack>
            ))}
        </>
    )
}
